import React, { useState } from 'react';

import Input from 'components/Input';
import { TEXT_SURVEY_LIST } from 'constants/string/texts';

const SurveyListSearch = ({ onSubmit }) => {
  const [keyword, setKeyword] = useState('');

  return (
    <>
      <div aria-labelledby="search-form" className="mt-6">
        <div className="w-1/3 relative">
          <Input
            type="search"
            value={keyword}
            allowClear={true}
            onClickClear={() => {
              setKeyword('');
              onSubmit('');
            }}
            onClickSearch={() => {
              onSubmit(keyword);
            }}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onSubmit(keyword);
              }
            }}
            onChange={(e) => {
              if (e.target.value === '' && keyword !== '') {
                onSubmit('');
              }
              setKeyword(e.target.value);
            }}
            placeholder={TEXT_SURVEY_LIST.PLACE_SEARCH_SURVEY}
          />
        </div>
      </div>
    </>
  );
};

export default React.memo(SurveyListSearch);
